import { create } from "zustand";
import { persist } from "zustand/middleware";

interface DarkModeState {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (value: boolean) => void;
  highContrastMode: boolean;
  toggleHighContrastMode: () => void;
}

export const useDarkModeStore = create<DarkModeState>()(
  persist(
    (set) => ({
      isDarkMode: window.matchMedia("(prefers-color-scheme: dark)").matches,
      toggleDarkMode: () => {
        set((state) => {
          const newMode = !state.isDarkMode;
          // Apply the class immediately
          if (newMode) {
            document.documentElement.classList.add("dark");
          } else {
            document.documentElement.classList.remove("dark");
          }
          return { isDarkMode: newMode };
        });
      },
      setDarkMode: (value: boolean) => {
        set({ isDarkMode: value });
        // Apply the class immediately
        if (value) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      },
      highContrastMode: false,
      toggleHighContrastMode: () => set((state) => ({ highContrastMode: !state.highContrastMode })),
    }),
    {
      name: "dark-mode-storage",
      version: 1,
      migrate: (persistedState: any, version: number) => {
        if (version < 1) {
          return {
            ...persistedState,
            isDarkMode: window.matchMedia("(prefers-color-scheme: dark)").matches,
          };
        }
        return persistedState;
      },
    }
  )
);
